import { ReactNode } from 'react';
import { Box } from '@mui/material';
import { tss } from 'tss-react/mui';

interface AuthLayoutProps {
  children: ReactNode;
  className?: string;
}

const useStyles = tss.create(({ theme }) => ({
  root: {
    display: 'flex',
    minHeight: '100vh',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: theme.palette.surface.page,
  },
}));

export const AuthLayout = ({ children, className }: AuthLayoutProps) => {
  const { classes, cx } = useStyles();
  return <Box className={cx(classes.root, className)}>{children}</Box>;
};
